import * as React from 'react';
import cx from 'classnames';
import RadioList from 'components/Radio/RadioList';
import styles from './PincodeSuggestion.css';
import { stringTemplate } from 'components/StringWidget/StringWidget';
const onPincodeSelectionChanged = (props) => (checkedId) => {
    const { suggestions } = props;
    const suggestion = suggestions.find(suggestion => suggestion.key === checkedId);
    props.onPincodeSelectionChanged((suggestion && suggestion.pincode) || '');
};
const handleLoginModal = (props) => () => {
    props.onLoginClicked();
};
export default function pincodeSuggestion(props) {
    let { suggestions = [], pincodeText, userState } = props;
    suggestions.map((suggestion, i) => {
        suggestion.key = `${suggestion.pincode} + ${i}`;
    });
    const userLoggedIn = userState && userState.isLoggedIn;
    const logInLink = !userLoggedIn && (<div className={cx(styles['suggestion-title'], styles['login-title'])} onClick={handleLoginModal(props)}>
			<span className={styles['link']}>{stringTemplate('loginTitleTxt')}</span>
			{stringTemplate('seeYourAddress')}
		</div>);
    const pincodeSuggestionList = suggestions.length > 0 && (<React.Fragment>
			<div className={styles['suggestion-title']}>{stringTemplate('pincodeHistory')}</div>
			<RadioList name={'suggestionList'} onChange={onPincodeSelectionChanged(props)}>
				{suggestions.map(suggestion => {
        if (!suggestion) {
            return null;
        }
        return (<div className={styles['info']} key={suggestion.key} data-checked={pincodeText === suggestion.pincode}>
							<div className={styles['title-text']}>{suggestion.pincode}</div>
							{suggestion.address && <div className={styles['sub-text']}> {suggestion.address} </div>}
						</div>);
    })}
			</RadioList>
		</React.Fragment>);
    // If user is logged-in and no suggestions exist, no need to render this content
    if (userLoggedIn && suggestions.length === 0) {
        return null;
    }
    return (<div className={styles['suggestion-container']}>
			<div className={styles['suggestion-list']}>
				<div className={styles['sticky']}/>
				{!userLoggedIn ? logInLink : pincodeSuggestionList}
			</div>
			{suggestions.length > 2 && <div className={styles['fade-area']}/>}
		</div>);
}
